module.exports = __webpack_public_path__ + "static/img/200107.0c70fd02.png";